import { Component, inject } from '@angular/core';
import { MessengerService } from '../../../services/messenger/messenger.service';

@Component({
  selector: 'app-external-link-modal',
  standalone: true,
  templateUrl: './external-link-modal.html',
  styleUrl: './external-link-modal.scss',
})
export class ExternalLinkModal {
  private messengerService = inject(MessengerService);
  public externalUrl = this.messengerService.externalUrl;

  confirm() {
    const url = this.externalUrl();
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }
}
